import axios from "axios";
import { Notify, Toast } from 'vant'
import store from "@/store";
import {
  getToken
} from "@/utils/auth";
import router from '@/router/index.js'
// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 1000 * 30, // request timeout
});

// request interceptor
service.interceptors.request.use(
  (config) => {
    // do something before request is sent
    const token = getToken();
    if (token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers["Authorization"] = "Bearer " + token;
    }
    return config;
  },
  (error) => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  (response) => {
    const res = response.data;

    // 判断是否是登录接口
    if (response.config.url.indexOf("/user/oauth/token") !== -1) {
      return res;
    }
    // 判断是否是登录接口
    if (response.config.url.indexOf("/user/introspect") !== -1) {
      return res;
    }

    // if the custom code is not 20000, it is judged as an error.
    if (res.code !== 0) {
      Notify({
        message: res.message || "Error",
        type: "danger",
        duration: 3 * 1000,
      });

      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        // to re-login
        // MessageBox.confirm(
        //   "你已经登出，点取消留在此页, 或者重新登录",
        //   "登出确认", {
        //     confirmButtonText: "重新登录",
        //     cancelButtonText: "取消",
        //     type: "warning"
        //   }
        // ).then(() => {
        //   store.dispatch("user/resetToken").then(() => {
        //     location.reload();
        //   });
        // });
      }
      return Promise.reject(new Error(res.message || "Error"));
    } else {
      return res;
    }
  },
  (error) => {
		console.log('request error:', error)
		if (error.response) {
			switch (error.response.status) {
				case 401:
					console.log('401')
					store.dispatch('user/resetToken').then(() => {
						location.reload()
					})
					// 401 不弹出
					return Promise.reject(error)
			}
		}
		// 等待审核
		if (error.response.config.url === '/user/t/customer/auth/inviteCode/register' || error.response.config.url === '/user/t/customer/auth/register/bind/superiors') {
			Toast.success('注册成功，请等待审核')
      setTimeout(() => {
        router.push({
          path: '/registerSuccessTip',
        })
      }, 2000);
			return Promise.reject(error)
		}
		console.log('err' + error) // for debug
		Notify({
			message: error.message,
			type: 'danger',
			duration: 5 * 1000,
		})
		return Promise.reject(error)
  }
);

export default service;